import { Component } from '@angular/core';
import { E5coreUiWorkTabBaseComponent } from './e5code-ui-work-tab-base';

@Component({
  selector: 'e5core-ui-work-tab-box',
  templateUrl: './e5core-ui-work-tab-box.component.html',
  styleUrls: ['./e5core-ui-work-tab-box.component.css']
})
export class E5coreUiWorkTabBoxComponent extends E5coreUiWorkTabBaseComponent {

}
